import React, { useEffect, useState, useContext } from "react";
import { InputBaseProps } from "./InputBase";
import { LabelContext } from "../labels/LabelContext";
import classNames from "classnames";
import styles from "./InputBase.scss";

export interface TextAreaProps extends InputBaseProps<string> {
  /**
   * Control height
   */
  rows?: number;
}

/**
 * Input element with the corresponding aria tags.
 */
export const TextArea: React.FC<TextAreaProps> = ({size = 'block', ...props}) => {
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    if (value != props.value) {
      setValue(props.value);
    }
  }, [props.value]);

  const onChange = () => {
    if(value != props.value) {
      props.onChange && props.onChange(value)
    }
  }

  const ctx = useContext(LabelContext);

  const state = ctx.state || props.state;

  return (
    <textarea
      id={props.id || ctx.id}
      name={props.name}
      className={classNames(styles["au-text-input"], {
        [styles[`au-text-input--${state}`]]: state,
        [styles[`au-text-input--width-${size}`]]: size && size != 'block',
        [styles[`au-text-input--block`]]: size == 'block'
      }, props.className)}
      aria-labelledby={props.describedBy || ctx.describedBy}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={onChange}
      disabled={props.disabled}
      readOnly={props.readonly}
      style={props.rightAlign ? { textAlign: "right" } : {}}
      placeholder={props.placeholder}
      maxLength={props.maxLength}
      rows={props.rows}
    />
  );
};
